"use strict";

module.exports = require("./is-implemented")()
	? Object.assign
	: require("./shim");



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/assign/index.js
// module id = 6
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/es5-ext/object/assign/index.js